<h4 class="align-center">Registration Successful</h4>
<div class="message-container">
  <p>Please verify your email addess by clicking the "Verify Account" link that has been sent to:<br><br><b>{{ email ? email : 'your email' }}</b></p>
</div>
<br>
<div class="message-container">
  <button color="primary" mat-stroked-button routerLink="/identity"> Back to Login </button>
</div>
